import { User } from "firebase/auth";
import { makeAutoObservable } from "mobx";

class UIStore {
	constructor() {
		makeAutoObservable(this);
	}

	private _isLoading = false;
	public get isLoading() {
		return this._isLoading;
	}
	public set isLoading(value: boolean) {
		this._isLoading = value;
	}
	private _user: User | null | undefined = undefined;
	public get user() {
		return this._user;
	}
	public set user(value: User | null | undefined) {
		this._user = value;
	}
	public get isLoggedIn() {
		return this._user !== null;
	}
}

const uiStore = new UIStore();
export default uiStore;
